import { IActivityHistoryItem } from "../domain/model";

export const updateItemInCollection = (
  collections: Record<string, any>,
  id: string,
  updatedItem: IActivityHistoryItem,
) => {
  if (!collections[id]?.items) return collections;
  const items = collections[id]?.items ?? [];

  return {
    ...collections,
    [id]: {
      ...collections[id],
      items: items.map((i: IActivityHistoryItem) => (i.id === updatedItem.id ? updatedItem : i)),
    },
  };
};
